const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotarinIconImmobilien(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 519 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-40.9022,-1.77636e-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Immobilie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.177,470.148L322.177,503.004",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03903,0,0,1.54656,-15.2985,-14.6399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.958,9.466L504.958,43.244L101.403,43.244L101.403,9.466L504.958,9.466ZM488.69,20.396L117.672,20.396C117.672,20.396 117.672,32.314 117.672,32.314L488.69,32.314L488.69,20.396Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.28408,0,0,1.42025,-89.3067,538.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.958,9.466L504.958,43.244L101.403,43.244L101.403,9.466L504.958,9.466ZM491.794,21.368L114.567,21.368L114.567,31.342L491.794,31.342L491.794,21.368Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.352,52.239L120.352,552.027",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.351,52.239L480.351,552.027",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.654,90.163L228.654,184.599L151.427,184.599L151.427,90.163L228.654,90.163ZM211.75,107.067L168.331,107.067L168.331,167.695L211.75,167.695L211.75,107.067ZM449.098,90.163L449.098,184.599L371.872,184.599L371.872,90.163L449.098,90.163ZM432.194,107.067L388.775,107.067L388.775,167.695L432.194,167.695L432.194,107.067ZM339.587,90.163L339.587,184.599L262.36,184.599L262.36,90.163L339.587,90.163ZM322.683,107.067L279.264,107.067L279.264,167.695L322.683,167.695L322.683,107.067ZM228.654,240.208L228.654,334.643L151.427,334.643L151.427,240.208L228.654,240.208ZM211.75,257.112L168.331,257.112L168.331,317.739L211.75,317.739L211.75,257.112ZM449.098,240.208L449.098,334.643L371.872,334.643L371.872,240.208L449.098,240.208ZM432.194,257.112L388.775,257.112L388.775,317.739L432.194,317.739L432.194,257.112ZM339.587,240.208L339.587,334.643L262.36,334.643L262.36,240.208L339.587,240.208ZM322.683,257.112L279.264,257.112L279.264,317.739L322.683,317.739L322.683,257.112ZM228.654,402.341L228.654,496.777L151.427,496.777L151.427,402.341L228.654,402.341ZM211.75,419.245L168.331,419.245L168.331,479.873L211.75,479.873L211.75,419.245ZM449.098,402.341L449.098,496.777L371.872,496.777L371.872,402.341L449.098,402.341ZM432.194,419.245L388.775,419.245L388.775,479.873L432.194,479.873L432.194,419.245ZM351.676,402.341L351.676,568.599L248.138,568.599L248.138,402.341L351.676,402.341ZM334.772,419.245L265.042,419.245L265.042,551.695L334.772,551.695L334.772,419.245Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarinIconImmobilien);
export default __webpack_public_path__ + "static/media/Notarin_Icon_Immobilien.fe8d0965e11e711948789fd8e7aec452.svg";
export { ForwardRef as ReactComponent };